import React from 'react'
import { GenericGraph } from '../../utils/GenericGraph'
import WordGraph from './WordGraph'

const BiComment = (props) => {
    var polarity = props.data.polarity
    var act = []
    for (var p in polarity){
        act.push({y:polarity[p],label:p})
    }

    const options_1 = {
        animationEnabled: true,
        // height:graph_height,
        title: {
            text: "Rating",
            fontFamily: "verdana"
        },
        subtitles:[
            {
                text: props.data.qn,
                fontFamily: "verdana",   
                fontSize: 12,
            }
        ],
        // axisY: axisY({interval: 2000,includeZero: false}),
        // axisX: axisX({title:"Name"}),
        toolTip: {
            enabled: true, 
            fontSize:13,
            // contentFormatter: function ( e ) {
            //     console.log(e);
            //     return e.entries[0].dataPoint.label + " " + Math.round(e.entries[0].dataPoint.y*1000).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") ;
            // },  
            borderThickness: 0,
            backgroundColor: "rgba(255,255,255,0.75)",
            borderColor: "rgba(255,255,255,0.75)",
            animationEnabled: true,
        },
        data: [{
            dataPoints: act
        },]
    }
    return (
    <div style={{boxShadow: "rgba(0, 0, 0, 0.25) 0px 54px 55px, rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px, rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px",
        padding: "5%",width:"50%"}}>
            <GenericGraph options={options_1} />  
            
            {
                "negative_keywords" in props.data &&   <div style={{margin:"20px"}}>
                    <h3 >Negative Keywords</h3>
                    <WordGraph data={props.data.negative_keywords}/>
                </div>
            }

            {
                "positive_keywords" in props.data &&     <div style={{margin:"20px"}}>
                    <h3>Positive Keywords</h3>
                    <WordGraph data={props.data.positive_keywords}/>
                </div>
            }
    </div>
  )
}

export default BiComment
